import { MaskedInput } from 'roo-ui/components';
import { numberMask } from 'lib/inputMasks';

const NumberInput = (props) => <MaskedInput mask={numberMask} {...props} />;

export default NumberInput;
